import React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import findResult from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import Dialog from '@/components/dialogs/Dialog';
import PermissionsTable from '../components/PermissionsTable';
import { hideConfirmPermissions, updateRole } from '../actions';
import { permissionsDiff, categoriesFromPermissions } from '../helper';

const ConfirmPermissionsDialog = ({
  category,
  code,
  grouping,
  hide,
  name,
  permissions,
  save,
  theme,
  updateStatus,
}) => {
  const intl = useIntl();
  return (
    <Dialog
      className="aridhia-confirm-permissions-dialog smallwizard"
      icon="drivers license"
      inProgress={updateStatus === states.PENDING}
      messageIcon="warning circle"
      message="permissions.changes.text"
      minimumDataEntryMet
      onClose={hide}
      onSave={() => save(category, code)}
      saveMessageId="actions.modify"
      size="small"
      theme={theme}
      title={intl.formatMessage({ id: 'permissions.changes.title' })}
      values={{ roleName: name }}
      warning
    >
      <div className="aridhia-permissions-dialog-container">
        <PermissionsTable
          category={category}
          code={code}
          disabled
          grouping={grouping}
          categories={categoriesFromPermissions(permissions, grouping)}
        />
      </div>
    </Dialog>
  );
};

const mapStateToProps = ({
  roles: { activeRole: { category, code }, roles },
}) => {
  const item = findResult(roles, category, code);
  return ({
    category,
    code,
    grouping: item ? item.grouping : '',
    name: item ? item.name : '',
    permissions: item ? permissionsDiff(item) : [],
    updateStatus: item ? item.updateStatus : states.NONE,
  });
};

const mapDispatchToProps = {
  hide: hideConfirmPermissions,
  save: updateRole,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmPermissionsDialog);
